"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown2FilterInput = exports.ClickWall = exports.Dropdown2Menu = exports.Dropdown2MenuItem = exports.Dropdown2 = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var Icon_1 = require("../Icon");
var mobile_1 = require("../../utils/mobile");
var translation_1 = require("../../utils/translation");
var TIP_WIDTH = 13;
var enhanceDropdown2 = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('dropdown2'), (0, recompose_1.withState)('isStateOpen', 'setIsOpen', false), (0, recompose_1.withState)('dropdown', 'setDropdown', null), (0, recompose_1.defaultProps)({ clickable: true }), recompose_1.pure);
exports.Dropdown2 = enhanceDropdown2(function (props) {
    var isOpen = typeof props.isOpen === 'undefined' ? props.isStateOpen : props.isOpen;
    var element = props.children[0];
    if (!props.disabled && typeof element === 'object') {
        element = React.Children.map(element, function (child, id) {
            if (typeof child === 'object') {
                return React.cloneElement(child, {
                    key: "dropdown-controller-".concat(id),
                    onClick: function (e) {
                        if (!props.clickable) {
                            return;
                        }
                        if (props.onChange) {
                            props.onChange(!props.isOpen, e);
                        }
                        else {
                            props.setIsOpen(!props.isStateOpen);
                        }
                    }
                });
            }
            else {
                return child;
            }
        });
    }
    return (React.createElement("div", { className: classNames('sok-dropdown2', props.disabled && 'disabled', { mobile: mobile_1.isMobile }, props.className), style: props.style, ref: props.setDropdown },
        element,
        isOpen &&
            props.dropdown &&
            props.children[1] &&
            React.cloneElement(props.children[1], {
                isOpen: isOpen,
                onClose: function (e) {
                    setTimeout(function () {
                        if (props.onChange) {
                            props.onChange(false, e);
                        }
                        else {
                            props.setIsOpen(false);
                        }
                    });
                },
                alignment: props.alignment,
                direction: props.direction,
                parent: props.parent || props.dropdown
            })));
});
var enhanceDropdown2Menu = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Dropdown2Menu'), (0, recompose_1.withState)('reference', 'setReference', null), (0, recompose_1.withState)('menutip', 'setMenutip', null), (0, recompose_1.defaultProps)({ container: document.body }), recompose_1.pure);
exports.Dropdown2MenuItem = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Dropdown2MenuItem'), recompose_1.pure)(function (_a) {
    var className = _a.className, children = _a.children, selected = _a.selected, disableAutoScroll = _a.disableAutoScroll, disabled = _a.disabled, props = __rest(_a, ["className", "children", "selected", "disableAutoScroll", "disabled"]);
    var ref = undefined;
    if (selected && !disableAutoScroll) {
        ref = React.useRef(null);
        React.useEffect(function () {
            if (ref && ref.current) {
                ref.current.scrollIntoView({ block: 'center', inline: 'center' });
            }
        }, [selected, disableAutoScroll]);
    }
    return (React.createElement("div", __assign({ ref: ref, className: classNames('sok-dropdown2-menu-item', {
            selected: selected,
            disabled: disabled
        }, className) }, props, { onClick: !disabled && props.onClick }), children));
});
// TODO: refactor this component to use recompose
exports.Dropdown2Menu = enhanceDropdown2Menu(/** @class */ (function (_super) {
    __extends(Dropdown2Menu, _super);
    function Dropdown2Menu(p) {
        var _this = _super.call(this, p) || this;
        _this.position = _this.position.bind(_this);
        _this.outsideClick = _this.outsideClick.bind(_this);
        _this.optimizeDirection = _this.optimizeDirection.bind(_this);
        return _this;
    }
    Dropdown2Menu.prototype.componentDidMount = function () {
        if (!mobile_1.isMobile) {
            window.addEventListener('resize', this.position);
            window.addEventListener('scroll', this.position);
        }
        window.addEventListener('scrollbar:wheel', this.position);
        document.body.addEventListener('click', this.outsideClick);
    };
    Dropdown2Menu.prototype.componentWillUnmount = function () {
        if (!mobile_1.isMobile) {
            window.removeEventListener('resize', this.position);
            window.removeEventListener('scroll', this.position);
        }
        window.removeEventListener('scrollbar:wheel', this.position);
        document.body.removeEventListener('click', this.outsideClick);
    };
    Dropdown2Menu.prototype.componentDidUpdate = function () {
        if (!mobile_1.isMobile) {
            this.position();
        }
    };
    Dropdown2Menu.prototype.optimizeDirection = function (direction) {
        if (direction === void 0) { direction = 'down'; }
        if (!this.props.parent || !this.props.reference) {
            return direction;
        }
        var menuHeight = this.props.reference.getBoundingClientRect().height + 14;
        var dropdownRect = this.props.parent.getBoundingClientRect();
        if (dropdownRect.top < menuHeight &&
            window.innerHeight - dropdownRect.bottom < menuHeight) {
            return dropdownRect.top > window.innerHeight - dropdownRect.bottom
                ? 'up'
                : 'down';
        }
        else if (dropdownRect.top < menuHeight) {
            return 'down';
        }
        else if (window.innerHeight - dropdownRect.bottom < menuHeight) {
            return 'up';
        }
        else {
            return direction;
        }
    };
    Dropdown2Menu.prototype.position = function () {
        var props = this.props;
        window.requestAnimationFrame(function () {
            if (!props.reference || !props.parent) {
                return;
            }
            var alignment = props.alignment, direction = props.direction;
            var menu = props.reference;
            var parent = props.parent;
            var menutip = props.menutip;
            var parentRect = parent.getBoundingClientRect();
            var menuRect = menu.getBoundingClientRect();
            var menuRectWidth = menuRect.width;
            if (parentRect.width > menuRectWidth && !props.ignoreWidth) {
                menu.style.minWidth = parentRect.width + 'px';
                menu.style.width = parentRect.width + 'px';
                menuRectWidth = parentRect.width;
            }
            if (document.body.clientWidth < menuRectWidth && !props.ignoreWidth) {
                menu.style.minWidth = parentRect.width + 'px';
                menu.style.width = parentRect.width + 'px';
            }
            var distance = 0;
            if (alignment === 'left') {
                menu.style.left = parentRect.left - TIP_WIDTH + 'px';
                var tipPosition = parentRect.width / 2;
                if (tipPosition < menuRect.width / 2) {
                    menutip.style.left = tipPosition + 'px';
                }
                else {
                    menutip.style.left = menuRect.width / 2 + 'px';
                }
            }
            else if (alignment === 'right') {
                menu.style.left =
                    Math.abs(parentRect.right - menuRectWidth - TIP_WIDTH) + 'px';
                menu.style.right = null;
                var tipPosition = parentRect.width / 2 - TIP_WIDTH / 2;
                if (tipPosition < menuRect.width / 2) {
                    menutip.style.right = tipPosition + 'px';
                }
                else {
                    menutip.style.right = menuRect.width / 2 + 'px';
                }
            }
            else {
                distance = parentRect.width / 2 - menuRectWidth / 2;
                // left overflow
                if (parentRect.left + distance < 0) {
                    menu.style.left = '0';
                    menu.style.right = null;
                    var pos = parentRect.left + parentRect.width / 2 - TIP_WIDTH;
                    if (pos > TIP_WIDTH / 2) {
                        menutip.style.left = Math.abs(pos) + 'px';
                    }
                    else {
                        menutip.style.left = TIP_WIDTH + 'px';
                    }
                    menutip.style.right = null;
                }
                // right overflow
                else if (document.body.clientWidth - parentRect.right + distance <
                    0) {
                    menu.style.left = null;
                    menu.style.right = '0px';
                    menutip.style.left = null;
                    var pos = document.body.clientWidth - parentRect.right - TIP_WIDTH;
                    if (pos > TIP_WIDTH / 2) {
                        menutip.style.right = pos + 'px';
                        var tipRect = menutip.getBoundingClientRect();
                        var diff = ~~(tipRect.left - parentRect.left);
                        if (diff !== 0) {
                            menutip.style.right = pos + diff / 2 + 'px';
                        }
                    }
                    else {
                        menutip.style.right = TIP_WIDTH / 2 + 'px';
                    }
                }
                // no overflow
                else {
                    menu.style.left = parentRect.left + distance - TIP_WIDTH + 'px';
                    menu.style.right = null;
                    menutip.style.left = menuRectWidth / 2 + 'px';
                    menutip.style.right = null;
                }
            }
            if (direction === 'up' ||
                (direction === undefined && props.reference.classList.contains('up'))) {
                menu.style.top = null;
                menu.style.bottom = window.innerHeight - parentRect.top + 'px';
            }
            else {
                menu.style.top = parentRect.bottom + 'px';
                menu.style.bottom = null;
            }
        });
    };
    /**
     * Detect click on document
     *
     * If clicked inside dropdown menu, close dropdown
     * If clicked inside dropdown toggle button, don't close dropdown
     * If clicked inside <ClickWall />, click propagation will be stopped
     * If clicked outside dropdown, close dropdown
     */
    Dropdown2Menu.prototype.outsideClick = function (e) {
        var _this = this;
        var target = e.target;
        var wallFounded = false;
        var findWall = function (node) {
            if (node === undefined || node === null) {
                return 'NONE';
            }
            else if (node === _this.props.parent) {
                return 'NONE';
            }
            else if (node.nodeName.toLowerCase() === 'body') {
                return 'CLOSE';
            }
            else if (typeof node.className === 'string') {
                if (node.classList.contains('sok-click-wall')) {
                    wallFounded = true;
                }
                if (node === _this.props.reference) {
                    return wallFounded ? 'WALL' : 'CLOSE';
                }
            }
            return findWall(node.parentElement);
        };
        // Lets ignore this event if we click to 'ClickWall' component
        var status = findWall(target);
        if (status === 'WALL') {
            return;
        }
        else if (status === 'CLOSE') {
            this.props.onClose(e);
        }
    };
    Dropdown2Menu.prototype.render = function () {
        var _a = this.props, alignment = _a.alignment, direction = _a.direction, children = _a.children, className = _a.className, style = _a.style;
        return ReactDOM.createPortal(React.createElement("div", { ref: this.props.setReference, className: classNames('sok-dropdown2-menu', { mobile: mobile_1.isMobile }, alignment ? alignment : 'center', direction ? direction : this.optimizeDirection(direction), this.props.isOpen ? 'open' : null, className), style: style },
            React.createElement("div", { ref: this.props.setMenutip, className: "sok-dropdown2-menu-tip" }),
            React.createElement("div", { className: "sok-dropdown2-menu-content" }, children || React.createElement(exports.Dropdown2MenuItem, { disabled: true })),
            React.createElement("div", { className: "sok-dropdown2-menu-close" },
                React.createElement(Icon_1.Icon, { className: "fa-times fa-fw" }),
                " Close")), this.props.container || document.body);
    };
    return Dropdown2Menu;
}(React.Component)));
// Typescript cant type this correctly
var ClickWall = function (props) {
    return React.Children.map(props.children, function (child) {
        if (typeof child === 'object') {
            return React.cloneElement(child, __assign(__assign({}, child.props), { className: classNames('sok-click-wall', child.props.className) }));
        }
        else {
            return React.createElement("span", null, child);
        }
    });
};
exports.ClickWall = ClickWall;
var Dropdown2FilterInput = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("input", __assign({ className: classNames('sok-dropdown2-filter-input', className), type: "search", placeholder: (0, translation_1.getLocalization)('components/Dropdown2/filterPlaceholder') }, props)));
};
exports.Dropdown2FilterInput = Dropdown2FilterInput;
//# sourceMappingURL=index.js.map